import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import {useTranslation} from "react-i18next";
import {Outlet} from "react-router-dom";
import './LoginLayout.scss'

export const LoginLayout = () =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation(['translation', 'override']);

    return (
        <Container fluid className="vh-100 bg-body-secondary">
            <Row className="h-100">
                {/* Left column with logo */}
                <Col xs={12} md={4} className="d-flex flex-column p-4">
                    <div className="mt-4 text-md-start text-center">
                        <img src={t(['override:login.logo', 'login.logo'])} alt="CipherMail Logo" className="login-logo-width" />
                    </div>
                </Col>

                {/* Middle column with login form */}
                <Col xs={12} md={4} className="login-column d-flex align-items-center justify-content-center">
                    {/* The child "pages" will be added here*/}
                    <Outlet/>
                </Col>

                {/* Right column (empty for now) */}
                <Col xs={12} md={4} className="d-none d-md-block"></Col>
            </Row>
        </Container>
    );
}
